<script setup lang="ts">
  import { useRouter } from 'vue-router'

  const props = defineProps<{
    href?: string
    to?: string
    target?: string
    click?: () => void
    iconLeft?: string
    iconRight?: string
    disabled?: boolean
  }>()

  const router = useRouter()

  const onClick = function () {
    if (props.disabled) {
      return
    } else if (props.href) {
      return true
    } else if (props.to) {
      router.push(props.to)
    } else if (props.click) {
      props.click()
    }
  }

  function onKeydown(event: KeyboardEvent) {
    if (props.href || (event.key !== 'Enter' && (props.to || event.key !== ' '))) return

    event.preventDefault()
    onClick()
  }
</script>

<template>
  <a
    class="inline-flex items-center gap-1.5 font-medium whitespace-nowrap leading-4 select-none"
    :href="props.href ?? undefined"
    :role="props.href ? undefined : props.to ? 'link' : 'button'"
    :tabindex="props.href ? undefined : 0"
    :aria-disabled="props.disabled || undefined"
    :target="props.target ?? '_self'"
    :class="props.disabled ? 'cursor-not-allowed text-blue-90' : 'cursor-pointer text-blue-50 hover:underline'"
    @click="onClick"
    @keydown="onKeydown"
  >
    <des-icon :icon="['fa-light', iconLeft]" v-if="iconLeft"></des-icon>
    <slot></slot>
    <des-icon :icon="['fa-light', iconRight]" v-if="iconRight"></des-icon>
  </a>
</template>
